/**
 * Created by Jerker Nord on 2023-10-16.
 */
import {Loner} from "../../../../Loner";
import {PixelFont} from "../../../../fonts/PixelFont";
import {FontStyle, FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {LonerGameAssets} from "../../../../LonerGameAssets";
import {TimelineAnimatedSprite} from "../../../../utils/TimelineAnimatedSprite";

export class LonerBuilding extends PIXI.Container {

    private static TEXT_NORMAL_SIZE: string = "60px";

    private _multiplierText: PIXI.Text;

    protected _buildingSprite: PIXI.Sprite;
    protected _crater:PIXI.Sprite;
    protected _fireAnimation: TimelineAnimatedSprite;

    constructor() {
        super();
    }

    public init(building: string, fireAnimation: string): void {
        this._buildingSprite = new PIXI.Sprite(Loner.assetLoader.getTextures(building)[0]);
        this._buildingSprite.anchor.set(0.5, 0.5);
        this._buildingSprite.scale.set(2.5, 2.5);
        this.addChild(this._buildingSprite);

        this._multiplierText = new PIXI.Text("x000", new PIXI.TextStyle({
            align: "center",
            fontFamily: PixelFont.FAMILY,
            fontSize: "28px",
            fill: "#f0f0f0",
            fontStyle: FontStyle.NORMAL,
            fontWeight: FontWeight.BOLD,
            dropShadow: true,
            dropShadowAlpha: 1,
            dropShadowAngle: Math.PI * 0.5,
            dropShadowBlur: 4,
            dropShadowColor: "#000000",
            dropShadowDistance: 2,
            padding: 20,
            stroke: 2,
            strokeThickness: 2
        }));
        this._multiplierText.anchor.set(0.5, 0);
        this._multiplierText.visible = false;
        this.addChild(this._multiplierText);

        this._fireAnimation = new TimelineAnimatedSprite(Loner.assetLoader.getTextures(fireAnimation),-1, 2);
        this._fireAnimation.anchor.set(0.5, 0.5);
        this._fireAnimation.position.y = (this._buildingSprite.height / 2) - (this._fireAnimation.height / 2);
        this._fireAnimation.visible = false;
        this.addChild(this._fireAnimation);

        this._crater = new PIXI.Sprite(Loner.assetLoader.getTextures(LonerGameAssets.TTB_BUILDING_CRATER)[0]);
        this._crater.anchor.set(0.5, 0.5);
        this._crater.visible = false;
        this._crater.position.y = (this._buildingSprite.height / 2) - (this._crater.height / 2);
        this.addChild(this._crater);

        this._fireAnimation.play();
    }

    public playFireAnimation(): void {
        this._fireAnimation.visible = true;
    }

    public setText(newText: string, isWin: boolean): void {
        this._multiplierText.text = "x" + newText;
        this._multiplierText.style.fontSize = LonerBuilding.TEXT_NORMAL_SIZE;
        this._multiplierText.position.set(0, 0 - ((this.height / 2) + this._multiplierText.height));
    }

    public reset(): void {
        this._fireAnimation.visible = false;
        this._multiplierText.visible = false;
        this._buildingSprite.visible = true;
        this._crater.visible = false;
    }

    public showText(): void {
        this._multiplierText.visible = true;
    }

    get buildingSprite(): PIXI.Sprite {
        return this._buildingSprite;
    }
}